/**
 * Lazy-loads the widget's math renderer (widget-math.js) the first time a reply
 * contains math. One request per page, shared by every message; a failed load is not
 * retried on every streamed chunk — the math simply stays as readable TeX.
 */

export type MathRenderer = (tex: string, display: boolean) => string;

let baseUrl = "";
let loading: Promise<MathRenderer | null> | null = null;

/** Where widget-math.js lives: the same backend origin that served widget.js. */
export function configureMathLoader(apiBaseUrl: string): void {
  baseUrl = apiBaseUrl.replace(/\/$/, "");
}

export function loadMathRenderer(): Promise<MathRenderer | null> {
  const existing = (window as any).__uwtTutorMath;
  if (existing) return Promise.resolve(existing.render as MathRenderer);
  if (!loading) {
    loading = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = `${baseUrl}/widget-math.js`;
      script.async = true;
      script.onload = () => resolve(((window as any).__uwtTutorMath?.render as MathRenderer) ?? null);
      script.onerror = () => {
        console.warn("[UWT Tutor Widget] Math renderer failed to load — showing TeX as text.");
        resolve(null);
      };
      document.head.appendChild(script);
    });
  }
  return loading;
}
